import { useTranslation } from "react-i18next";
import Mobile from "../../../../assets/mobile-1.svg?react";
import GooglePlay from "components/GooglePlay/GooglePlay";
import "./i18n";
import "./Top.scss";

export const Top = () => {
  const { t } = useTranslation();
  return (
    <div className="section-top">
      <div className="top-background-figure" />
      <div className="container-top">
      <div className="container-top-row">
        <div className="container-top-col-xs-12 container-top-col-sm-7 container-top-col-12">
          <h1 className="top-title">{t("top:title")}<span>{t("top:eCommerce")}</span></h1>
          <h2 className="top-subtitle">{t("top:subtitle")}</h2>
          <div className="store-container">
          <span className="download-label">{t("top:download")}</span>
          <span className="download-label-mobile">{t("top:downloadMobile")}</span>
            <GooglePlay />
          </div>
        </div>
        <div className="container-top-col-xs-12 container-top-col-sm-5 container-top-col-12 mobile-image">
          <Mobile />
        </div>
      </div>
    </div>
    </div>
  );
};
